import type {ReadAllResponse} from './types';

/** Завершить ограниченную серию порций; неполный ответ никогда не превращается в ноль. */
export const readAllNotifications = async (
  readPage: (before?: string) => Promise<ReadAllResponse>,
  maxPages = 20,
): Promise<ReadAllResponse> => {
  let before: string | undefined;
  const seen = new Set<string>();
  for (let page = 0; page < maxPages; page += 1) {
    const result = await readPage(before);
    if (!result.hasMore) return result;
    if (!result.continuation || seen.has(result.continuation)) {
      throw new Error('Сервер не вернул продолжение массового прочтения');
    }
    before = result.continuation;
    seen.add(before);
  }
  throw new Error(
    'Прочитана часть уведомлений. Повторите действие для оставшихся',
  );
};
